/*  */
import { AxiosResponse } from 'axios';
import { AvailableLanguages } from '../context/LanguageContext/types';
import api from './api';
import { LeaderboardType, QuestionAnsweredType } from '../types/entities';

const gameService = {
  getTop9Leaderboard: (
    city: string,
    locale: AvailableLanguages = 'en',
  ): Promise<AxiosResponse<LeaderboardType[]>> =>
    api.get<any>(`/api/leaderboard/top10?locale=${locale}&city=${encodeURIComponent(city)}`),
  getRelativeLeaderboard: (
    documentId: string,
    locale: AvailableLanguages = 'en',
  ): Promise<AxiosResponse<LeaderboardType[]>> =>
    api.get<any>(`/api/leaderboard/my-relative-position/${documentId}?locale=${locale}`),
  createGameSession: (
    player: string,
    questions: string[],
    city: string,
    locale: AvailableLanguages = 'en',
  ): Promise<AxiosResponse<{ data: { documentId: string } }>> =>
    api.post<any>(`/api/game-sessions`, {
      data: {
        questions: { connect: questions },
        player: { connect: player },
        city,
        locale,
      },
    }),

  updateGameSessionAnswers: ({
    gameSessionDocumentId,
    questionsAnswered,
    locale = 'en',
  }: {
    gameSessionDocumentId: string;
    questionsAnswered: { question: string; answerId: number }[];
    locale?: string;
  }): Promise<
    AxiosResponse<{
      documentId: string;
      points: number;
      questionsAnswered: QuestionAnsweredType[];
    }>
  > =>
    api.put<any>(`/api/game-sessions/${gameSessionDocumentId}`, {
      populate: ['questionsAnswered'],
      locale,
      data: {
        questionsAnswered,
      },
    }),
};

export default gameService;
